export * from './comments.component';
export * from './comments.trans';
export * from './comments-new.component';
